import React from 'react'
import { useTranslation } from 'react-i18next'
import { ArrowRight } from 'lucide-react'
import { UpcomingIcon } from '@/src/renderer/components/icons/UpcomingIcon'
import { DormantIcon } from '@/src/renderer/components/icons/DormantIcon'
import { WithTooltip } from '@/src/renderer/components/ui/tooltip'
import type { Task } from '@/src/renderer/lib/db/models'

/**
 * Wohin eine Aufgabe ging, die Kurz notiert verlassen hat. Ruhe vor Wann: Eine ruhende Aufgabe
 * steht in **Ruhend**, auch wenn sie ein Datum trägt.
 */
export function movedDestination(task: Pick<Task, 'pausedAt' | 'startDate'>): 'dormant' | 'upcoming' | null {
  if (task.pausedAt != null) return 'dormant'
  if (task.startDate != null) return 'upcoming'
  return null
}

/**
 * **Pfeil auf die Seite, auf der sie jetzt steht** (gewünscht 28.09.2026) — im Stil des
 * Projekt-Schilds. „Verschoben" allein sagte weder wohin noch warum; der Tooltip nennt den Grund.
 */
export const MovedDestination: React.FC<{ task: Task }> = ({ task }) => {
  const { t } = useTranslation()
  const place = movedDestination(task)
  if (!place) return null
  const Icon = place === 'dormant' ? DormantIcon : UpcomingIcon
  const reason = t(place === 'dormant' ? 'quickNotes.moved.toDormant' : 'quickNotes.moved.toUpcoming')
  return (
    <WithTooltip content={reason}>
      <span className="inbox-moved-notice__destination" role="note" aria-label={reason}>
        <ArrowRight size={12} className="inbox-moved-notice__destination-arrow" aria-hidden="true" />
        <span className="inbox-moved-notice__destination-badge">
          <Icon size={12} />
          {t(`sidebar.${place}`)}
        </span>
      </span>
    </WithTooltip>
  )
}
